/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:flex;flex-direction:column;outline:0;width:100%}[_nghost-%COMP%]   .mat-list-item.active[_ngcontent-%COMP%]{background-color:#000}[_nghost-%COMP%]:focus > .mat-list-item[_ngcontent-%COMP%]:not(.expanded), [_nghost-%COMP%]:hover > .mat-list-item[_ngcontent-%COMP%]:not(.expanded){background-color:#fff!important}.mat-list-item[_ngcontent-%COMP%]{padding:8px 0;display:flex;width:auto}.mat-list-item[_ngcontent-%COMP%]   .routeIcon[_ngcontent-%COMP%]{margin-right:40px}"];
export { styles as styles };
